import { useEffect, useState } from 'react';
import EmptyResult from 'components/others/EmptyResult';
import LeadTableRow from './LeadTableRow';
import { useLead } from './context/LeadProvider';
import { useAuth } from 'context/AuthContext';
import { isManagerUser } from 'utils/helpers/access/hasUserAccess';
import * as apiLead from 'api/apiLeads';
import RecordAccessOffcanvas from '../RecordAccessOffcanvas';
import type { LeadType } from '@econtractor/types';
import type { LeadsTableProps } from './types';

const LeadsTableBody = ({ leadsList, fetchLeads, setClientInfoId, setTasksLeadId, setNewSale }: LeadsTableProps) => {
    const { auth } = useAuth();
    const { showTitle, showSource, showCreated, showAccess, showDate } = useLead();
    const [accessLead, setAccessLead] = useState<LeadType | null>(null);

    useEffect(() => {
        if (!accessLead) return;
        const fresh = leadsList?.find((lead) => lead.ID === accessLead.ID);
        if (!fresh) return;
        const prev = (accessLead.accessUsers || []).map((grant) => `${grant.ID}:${grant.accessLevel}`).sort().join('|');
        const next = (fresh.accessUsers || []).map((grant) => `${grant.ID}:${grant.accessLevel}`).sort().join('|');
        if (prev !== next) setAccessLead(fresh);
    }, [leadsList, accessLead]);
    const colSpan = 3
        + (showTitle ? 1 : 0)
        + (showSource ? 1 : 0)
        + (showCreated ? 1 : 0)
        + (showAccess ? 1 : 0)
        + (showDate ? 1 : 0);

    return (
        <tbody>
            {accessLead ? (
                <RecordAccessOffcanvas
                    show
                    setShow={(next) => {
                        if (!next) setAccessLead(null);
                    }}
                    grants={accessLead.accessUsers || []}
                    ownerId={accessLead.ownerId}
                    ownerName={accessLead.userName}
                    ownerEmail={accessLead.userEmail}
                    ownerPicture={accessLead.userPicture}
                    canManage={isManagerUser(auth?.user)}
                    onSave={async (grants) => {
                        const ok = await apiLead.setLeadAccess(accessLead.ID, grants);
                        if (ok) await fetchLeads(true);
                        return ok;
                    }}
                />
            ) : null}
            {leadsList &&
                leadsList?.map((lead) => (
                    <LeadTableRow
                        key={lead.ID}
                        lead={lead}
                        fetchLeads={fetchLeads}
                        setClientInfoId={setClientInfoId}
                        setTasksLeadId={setTasksLeadId}
                        setNewSale={setNewSale}
                        onOpenAccess={setAccessLead}
                    />
                ))}

            {leadsList.length === 0 && (
                <tr>
                    <td colSpan={colSpan}>
                        <EmptyResult />
                    </td>
                </tr>
            )}
        </tbody>
    );
};

export default LeadsTableBody;
